import script from "./ViaggioDirectionIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./ViaggioDirectionIndicator.vue?vue&type=script&setup=true&lang=js"

import "./ViaggioDirectionIndicator.vue?vue&type=style&index=0&id=070dac2c&scoped=true&lang=scss"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-070dac2c"]])

export default __exports__